import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    app_name: "RecruitFlow AI",
    tagline: "Recrutez sur les réseaux sociaux, sans effort.",
    get_started: "Commencer",
    login: "Connexion",
    register: "Créer un compte",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    agency_name: "Nom de l'agence",
    preferred_language: "Langue préférée",
    no_account: "Pas de compte ?",
    has_account: "Déjà un compte ?",
    dashboard: "Tableau de bord",
    social_posts: "Publications sociales",
    ai_generator: "Générateur IA",
    candidates: "Candidats",
    messaging: "Messagerie",
    forms: "Formulaires",
    notifications: "Notifications",
    new: "Nouveau",
    contacted: "Contacté",
    qualified: "Qualifié",
    placed: "Placé",
    total: "Total",
    name: "Nom",
    phone: "Téléphone",
    country: "Pays",
    experience: "Expérience",
    job_title: "Poste",
    language_level: "Niveau de langue",
    status: "Statut",
    tags: "Tags",
    notes: "Notes",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    add_candidate: "Ajouter un candidat",
    add_post: "Nouveau post",
    add_template: "Nouveau modèle",
    add_form: "Nouveau formulaire",
    title: "Titre",
    content: "Contenu",
    platforms: "Plateformes",
    groups: "Groupes",
    schedule: "Planifier",
    scheduled_at: "Planifié le",
    bulk_post: "Post en masse",
    generate: "Générer",
    generation_type: "Type de génération",
    job_ad: "Annonce d'emploi",
    tiktok_script: "Script TikTok",
    facebook_post: "Post Facebook",
    copy: "Copier",
    copied: "Copié !",
    hashtags: "Hashtags",
    details: "Détails",
    trigger_keyword: "Mot-clé déclencheur",
    message: "Message",
    whatsapp: "WhatsApp",
    messenger: "Messenger",
    form_title: "Titre du formulaire",
    form_description: "Description",
    fields: "Champs",
    add_field: "Ajouter un champ",
    public_link: "Lien public",
    submissions: "Candidatures",
    photo: "Photo",
    cv: "CV",
    welcome_back: "Bon retour",
    sign_in_subtitle: "Accédez à votre espace agence.",
    create_account: "Créer votre compte",
    signup_subtitle: "Commencez à recruter plus vite.",
    overview: "Vue d'ensemble",
    recent_candidates: "Candidats récents",
    recent_activity: "Activité récente",
    no_data: "Aucune donnée",
    mark_all_read: "Tout marquer comme lu",
    unread: "Non lus",
    all: "Tous",
    copy_link: "Copier le lien",
    view_submissions: "Voir les candidatures",
    add: "Ajouter",
    required: "Requis",
    field_label: "Libellé",
    field_type: "Type",
    options_csv: "Options (séparées par une virgule)",
    apply_now: "Postuler",
    submit: "Envoyer",
    thanks_submission: "Merci ! Votre candidature a été envoyée.",
    hero_headline: "Automatisez votre recrutement.",
    hero_sub: "Publiez sur Facebook, Instagram et TikTok. Générez vos annonces par IA. Gérez vos candidats dans un pipeline clair.",
    features: "Fonctionnalités",
    pricing: "Tarifs",
    contact: "Contact",
    feature_1_title: "Planificateur social",
    feature_1_desc: "Publiez et planifiez sur plusieurs plateformes et groupes en un clic.",
    feature_2_title: "Copywriter IA",
    feature_2_desc: "Rédigez annonces, scripts TikTok et posts Facebook en secondes.",
    feature_3_title: "CRM candidats",
    feature_3_desc: "Pipeline visuel de Nouveau à Placé avec notes et tags.",
    feature_4_title: "Formulaires",
    feature_4_desc: "Récoltez photo, CV et niveau de langue sur une page publique.",
    country_ph: "Ex: Hongrie",
    job_title_ph: "Ex: Soudeur",
    details_ph: "Ex: CDI, 2500€/mois, logement inclus",
    select_language: "Langue",
    drafts: "Brouillons",
    scheduled: "Planifiés",
    published: "Publiés",
    groups_csv: "Groupes (séparés par une virgule)",
    tags_csv: "Tags (séparés par une virgule)",
    confirm_delete: "Confirmer la suppression ?",
    back: "Retour",
    settings: "Paramètres",
    pipeline: "Pipeline",
    total_candidates: "Candidats totaux",
    total_posts: "Posts totaux",
    active_forms: "Formulaires actifs",
    go: "Aller",
    billing: "Facturation",
    pricing_headline: "Des tarifs simples, sans surprise.",
    pricing_sub: "Essayez RecruitFlow AI gratuitement pendant {days} jours. Sans carte bancaire.",
    start_trial: "Essai gratuit {days} jours",
    no_card_trial: "Aucune carte bancaire requise pour l'essai.",
    month: "mois",
    popular: "Populaire",
    current: "Actuel",
    current_plan: "Plan actuel",
    subscribe: "S'abonner",
    start_after_trial: "Activer maintenant",
    trial: "Essai",
    active: "Actif",
    days_left: "jours restants",
    renewed_until: "Renouvelé jusqu'au",
    trial_ends: "Essai se termine le",
    verifying_payment: "Vérification du paiement…",
    please_wait: "Merci de patienter.",
    payment_success: "Paiement réussi !",
    plan_activated: "Plan activé",
    billing_note: "Paiement mensuel sécurisé via Stripe. Annulable à tout moment.",
  },
  en: {
    app_name: "RecruitFlow AI",
    tagline: "Recruit on social media, effortlessly.",
    get_started: "Get started",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    agency_name: "Agency name",
    preferred_language: "Preferred language",
    no_account: "No account?",
    has_account: "Already have an account?",
    dashboard: "Dashboard",
    social_posts: "Social posts",
    ai_generator: "AI Generator",
    candidates: "Candidates",
    messaging: "Messaging",
    forms: "Forms",
    notifications: "Notifications",
    new: "New",
    contacted: "Contacted",
    qualified: "Qualified",
    placed: "Placed",
    total: "Total",
    name: "Name",
    phone: "Phone",
    country: "Country",
    experience: "Experience",
    job_title: "Job title",
    language_level: "Language level",
    status: "Status",
    tags: "Tags",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    add_candidate: "Add candidate",
    add_post: "New post",
    add_template: "New template",
    add_form: "New form",
    title: "Title",
    content: "Content",
    platforms: "Platforms",
    groups: "Groups",
    schedule: "Schedule",
    scheduled_at: "Scheduled at",
    bulk_post: "Bulk post",
    generate: "Generate",
    generation_type: "Generation type",
    job_ad: "Job ad",
    tiktok_script: "TikTok script",
    facebook_post: "Facebook post",
    copy: "Copy",
    copied: "Copied!",
    hashtags: "Hashtags",
    details: "Details",
    trigger_keyword: "Trigger keyword",
    message: "Message",
    whatsapp: "WhatsApp",
    messenger: "Messenger",
    form_title: "Form title",
    form_description: "Description",
    fields: "Fields",
    add_field: "Add field",
    public_link: "Public link",
    submissions: "Submissions",
    photo: "Photo",
    cv: "CV",
    welcome_back: "Welcome back",
    sign_in_subtitle: "Access your agency workspace.",
    create_account: "Create your account",
    signup_subtitle: "Start recruiting faster.",
    overview: "Overview",
    recent_candidates: "Recent candidates",
    recent_activity: "Recent activity",
    no_data: "No data",
    mark_all_read: "Mark all read",
    unread: "Unread",
    all: "All",
    copy_link: "Copy link",
    view_submissions: "View submissions",
    add: "Add",
    required: "Required",
    field_label: "Label",
    field_type: "Type",
    options_csv: "Options (comma-separated)",
    apply_now: "Apply",
    submit: "Submit",
    thanks_submission: "Thanks! Your application was submitted.",
    hero_headline: "Automate your recruitment.",
    hero_sub: "Post to Facebook, Instagram & TikTok. Generate ads with AI. Manage candidates in a clean pipeline.",
    features: "Features",
    pricing: "Pricing",
    contact: "Contact",
    feature_1_title: "Social scheduler",
    feature_1_desc: "Publish and schedule across platforms and groups in one click.",
    feature_2_title: "AI copywriter",
    feature_2_desc: "Draft job ads, TikTok scripts and Facebook posts in seconds.",
    feature_3_title: "Candidate CRM",
    feature_3_desc: "Visual pipeline from New to Placed with notes and tags.",
    feature_4_title: "Forms",
    feature_4_desc: "Collect photo, CV and language level on a public page.",
    country_ph: "e.g. Hungary",
    job_title_ph: "e.g. Welder",
    details_ph: "e.g. Full-time, €2500/mo, housing included",
    select_language: "Language",
    drafts: "Drafts",
    scheduled: "Scheduled",
    published: "Published",
    groups_csv: "Groups (comma-separated)",
    tags_csv: "Tags (comma-separated)",
    confirm_delete: "Confirm delete?",
    back: "Back",
    settings: "Settings",
    pipeline: "Pipeline",
    total_candidates: "Total candidates",
    total_posts: "Total posts",
    active_forms: "Active forms",
    go: "Go",
    billing: "Billing",
    pricing_headline: "Simple pricing. No surprises.",
    pricing_sub: "Try RecruitFlow AI free for {days} days. No credit card required.",
    start_trial: "Start {days}-day free trial",
    no_card_trial: "No credit card required for the trial.",
    month: "mo",
    popular: "Popular",
    current: "Current",
    current_plan: "Current plan",
    subscribe: "Subscribe",
    start_after_trial: "Activate now",
    trial: "Trial",
    active: "Active",
    days_left: "days left",
    renewed_until: "Renewed until",
    trial_ends: "Trial ends",
    verifying_payment: "Verifying payment…",
    please_wait: "Please wait.",
    payment_success: "Payment successful!",
    plan_activated: "Plan activated",
    billing_note: "Secure monthly payment via Stripe. Cancel anytime.",
  },
  hu: {
    app_name: "RecruitFlow AI",
    tagline: "Toborozzon a közösségi médiában, könnyedén.",
    get_started: "Kezdjük",
    login: "Bejelentkezés",
    register: "Regisztráció",
    logout: "Kijelentkezés",
    email: "Email",
    password: "Jelszó",
    agency_name: "Ügynökség neve",
    preferred_language: "Preferált nyelv",
    no_account: "Nincs fiókja?",
    has_account: "Már van fiókja?",
    dashboard: "Vezérlőpult",
    social_posts: "Közösségi posztok",
    ai_generator: "MI generátor",
    candidates: "Jelöltek",
    messaging: "Üzenetek",
    forms: "Űrlapok",
    notifications: "Értesítések",
    new: "Új",
    contacted: "Kapcsolatba lépve",
    qualified: "Minősített",
    placed: "Elhelyezve",
    total: "Összesen",
    name: "Név",
    phone: "Telefon",
    country: "Ország",
    experience: "Tapasztalat",
    job_title: "Munkakör",
    language_level: "Nyelvi szint",
    status: "Státusz",
    tags: "Címkék",
    notes: "Jegyzetek",
    save: "Mentés",
    cancel: "Mégsem",
    delete: "Törlés",
    edit: "Szerkesztés",
    create: "Létrehozás",
    add_candidate: "Jelölt hozzáadása",
    add_post: "Új poszt",
    add_template: "Új sablon",
    add_form: "Új űrlap",
    title: "Cím",
    content: "Tartalom",
    platforms: "Platformok",
    groups: "Csoportok",
    schedule: "Ütemezés",
    scheduled_at: "Ütemezve",
    bulk_post: "Tömeges poszt",
    generate: "Generálás",
    generation_type: "Generálás típusa",
    job_ad: "Állásajánlat",
    tiktok_script: "TikTok forgatókönyv",
    facebook_post: "Facebook poszt",
    copy: "Másolás",
    copied: "Másolva!",
    hashtags: "Hashtagek",
    details: "Részletek",
    trigger_keyword: "Kiváltó szó",
    message: "Üzenet",
    whatsapp: "WhatsApp",
    messenger: "Messenger",
    form_title: "Űrlap címe",
    form_description: "Leírás",
    fields: "Mezők",
    add_field: "Mező hozzáadása",
    public_link: "Nyilvános link",
    submissions: "Jelentkezések",
    photo: "Fotó",
    cv: "Önéletrajz",
    welcome_back: "Üdv újra",
    sign_in_subtitle: "Lépjen be ügynökségi fiókjába.",
    create_account: "Fiók létrehozása",
    signup_subtitle: "Kezdjen el gyorsabban toborozni.",
    overview: "Áttekintés",
    recent_candidates: "Legutóbbi jelöltek",
    recent_activity: "Legutóbbi tevékenység",
    no_data: "Nincs adat",
    mark_all_read: "Összes olvasottnak jelöl",
    unread: "Olvasatlan",
    all: "Összes",
    copy_link: "Link másolása",
    view_submissions: "Jelentkezések",
    add: "Hozzáad",
    required: "Kötelező",
    field_label: "Címke",
    field_type: "Típus",
    options_csv: "Opciók (vesszővel)",
    apply_now: "Jelentkezés",
    submit: "Küldés",
    thanks_submission: "Köszönjük! A jelentkezést elküldtük.",
    hero_headline: "Automatizálja a toborzást.",
    hero_sub: "Posztoljon Facebookra, Instagramra és TikTokra. Generáljon hirdetéseket MI-vel. Kezelje jelöltjeit egy tiszta folyamatban.",
    features: "Funkciók",
    pricing: "Árak",
    contact: "Kapcsolat",
    feature_1_title: "Közösségi ütemező",
    feature_1_desc: "Tegyen közzé és ütemezzen platformokra és csoportokra egy kattintással.",
    feature_2_title: "MI szövegíró",
    feature_2_desc: "Állásajánlatok, TikTok forgatókönyvek és Facebook posztok másodpercek alatt.",
    feature_3_title: "Jelölt CRM",
    feature_3_desc: "Vizuális folyamat Újtól Elhelyezettig, jegyzetekkel és címkékkel.",
    feature_4_title: "Űrlapok",
    feature_4_desc: "Fotó, önéletrajz és nyelvi szint egy nyilvános oldalon.",
    country_ph: "pl. Magyarország",
    job_title_ph: "pl. Hegesztő",
    details_ph: "pl. Főállás, 2500€/hó, szállás biztosítva",
    select_language: "Nyelv",
    drafts: "Piszkozatok",
    scheduled: "Ütemezett",
    published: "Közzétéve",
    groups_csv: "Csoportok (vesszővel)",
    tags_csv: "Címkék (vesszővel)",
    confirm_delete: "Biztos törli?",
    back: "Vissza",
    settings: "Beállítások",
    pipeline: "Folyamat",
    total_candidates: "Összes jelölt",
    total_posts: "Összes poszt",
    active_forms: "Aktív űrlapok",
    go: "Ugrás",
    billing: "Számlázás",
    pricing_headline: "Egyszerű árak. Nincs meglepetés.",
    pricing_sub: "Próbálja ki a RecruitFlow AI-t ingyen {days} napig. Nincs szükség bankkártyára.",
    start_trial: "{days} napos ingyenes próba",
    no_card_trial: "A próbához nincs szükség bankkártyára.",
    month: "hó",
    popular: "Népszerű",
    current: "Jelenlegi",
    current_plan: "Jelenlegi csomag",
    subscribe: "Előfizetés",
    start_after_trial: "Aktiválás most",
    trial: "Próba",
    active: "Aktív",
    days_left: "nap van hátra",
    renewed_until: "Megújítva eddig",
    trial_ends: "Próba vége",
    verifying_payment: "Fizetés ellenőrzése…",
    please_wait: "Kérjük, várjon.",
    payment_success: "Sikeres fizetés!",
    plan_activated: "Csomag aktiválva",
    billing_note: "Biztonságos havi fizetés Stripe-on keresztül. Bármikor lemondható.",
  },
  it: {
    app_name: "RecruitFlow AI",
    tagline: "Recluta sui social media, senza sforzo.",
    get_started: "Inizia",
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    email: "Email",
    password: "Password",
    agency_name: "Nome agenzia",
    preferred_language: "Lingua preferita",
    no_account: "Nessun account?",
    has_account: "Hai già un account?",
    dashboard: "Pannello",
    social_posts: "Post social",
    ai_generator: "Generatore AI",
    candidates: "Candidati",
    messaging: "Messaggistica",
    forms: "Moduli",
    notifications: "Notifiche",
    new: "Nuovo",
    contacted: "Contattato",
    qualified: "Qualificato",
    placed: "Collocato",
    total: "Totale",
    name: "Nome",
    phone: "Telefono",
    country: "Paese",
    experience: "Esperienza",
    job_title: "Posizione",
    language_level: "Livello linguistico",
    status: "Stato",
    tags: "Etichette",
    notes: "Note",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    create: "Crea",
    add_candidate: "Aggiungi candidato",
    add_post: "Nuovo post",
    add_template: "Nuovo modello",
    add_form: "Nuovo modulo",
    title: "Titolo",
    content: "Contenuto",
    platforms: "Piattaforme",
    groups: "Gruppi",
    schedule: "Pianifica",
    scheduled_at: "Pianificato per",
    bulk_post: "Post in massa",
    generate: "Genera",
    generation_type: "Tipo di generazione",
    job_ad: "Annuncio di lavoro",
    tiktok_script: "Script TikTok",
    facebook_post: "Post Facebook",
    copy: "Copia",
    copied: "Copiato!",
    hashtags: "Hashtag",
    details: "Dettagli",
    trigger_keyword: "Parola chiave",
    message: "Messaggio",
    whatsapp: "WhatsApp",
    messenger: "Messenger",
    form_title: "Titolo modulo",
    form_description: "Descrizione",
    fields: "Campi",
    add_field: "Aggiungi campo",
    public_link: "Link pubblico",
    submissions: "Candidature",
    photo: "Foto",
    cv: "CV",
    welcome_back: "Bentornato",
    sign_in_subtitle: "Accedi al tuo spazio agenzia.",
    create_account: "Crea il tuo account",
    signup_subtitle: "Inizia a reclutare più velocemente.",
    overview: "Panoramica",
    recent_candidates: "Candidati recenti",
    recent_activity: "Attività recente",
    no_data: "Nessun dato",
    mark_all_read: "Segna tutto come letto",
    unread: "Non letti",
    all: "Tutti",
    copy_link: "Copia link",
    view_submissions: "Vedi candidature",
    add: "Aggiungi",
    required: "Obbligatorio",
    field_label: "Etichetta",
    field_type: "Tipo",
    options_csv: "Opzioni (separate da virgola)",
    apply_now: "Candidati",
    submit: "Invia",
    thanks_submission: "Grazie! La tua candidatura è stata inviata.",
    hero_headline: "Automatizza il reclutamento.",
    hero_sub: "Pubblica su Facebook, Instagram e TikTok. Genera annunci con AI. Gestisci i candidati in una pipeline pulita.",
    features: "Funzionalità",
    pricing: "Prezzi",
    contact: "Contatti",
    feature_1_title: "Pianificatore social",
    feature_1_desc: "Pubblica e pianifica su più piattaforme e gruppi con un clic.",
    feature_2_title: "Copywriter AI",
    feature_2_desc: "Scrivi annunci, script TikTok e post Facebook in pochi secondi.",
    feature_3_title: "CRM candidati",
    feature_3_desc: "Pipeline visuale da Nuovo a Collocato con note e tag.",
    feature_4_title: "Moduli",
    feature_4_desc: "Raccogli foto, CV e livello linguistico su una pagina pubblica.",
    country_ph: "es. Ungheria",
    job_title_ph: "es. Saldatore",
    details_ph: "es. Tempo pieno, 2500€/mese, alloggio incluso",
    select_language: "Lingua",
    drafts: "Bozze",
    scheduled: "Pianificati",
    published: "Pubblicati",
    groups_csv: "Gruppi (separati da virgola)",
    tags_csv: "Etichette (separate da virgola)",
    confirm_delete: "Confermare eliminazione?",
    back: "Indietro",
    settings: "Impostazioni",
    pipeline: "Pipeline",
    total_candidates: "Candidati totali",
    total_posts: "Post totali",
    active_forms: "Moduli attivi",
    go: "Vai",
    billing: "Fatturazione",
    pricing_headline: "Prezzi semplici. Nessuna sorpresa.",
    pricing_sub: "Prova RecruitFlow AI gratis per {days} giorni. Nessuna carta richiesta.",
    start_trial: "Prova gratuita di {days} giorni",
    no_card_trial: "Nessuna carta di credito richiesta per la prova.",
    month: "mese",
    popular: "Popolare",
    current: "Attuale",
    current_plan: "Piano attuale",
    subscribe: "Abbonati",
    start_after_trial: "Attiva ora",
    trial: "Prova",
    active: "Attivo",
    days_left: "giorni rimanenti",
    renewed_until: "Rinnovato fino al",
    trial_ends: "La prova termina il",
    verifying_payment: "Verifica del pagamento…",
    please_wait: "Attendere prego.",
    payment_success: "Pagamento riuscito!",
    plan_activated: "Piano attivato",
    billing_note: "Pagamento mensile sicuro tramite Stripe. Cancellabile in qualsiasi momento.",
  },
  de: {
    app_name: "RecruitFlow AI",
    tagline: "Rekrutieren Sie in sozialen Medien, mühelos.",
    get_started: "Loslegen",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    agency_name: "Agenturname",
    preferred_language: "Bevorzugte Sprache",
    no_account: "Kein Konto?",
    has_account: "Bereits ein Konto?",
    dashboard: "Übersicht",
    social_posts: "Social-Posts",
    ai_generator: "KI-Generator",
    candidates: "Kandidaten",
    messaging: "Nachrichten",
    forms: "Formulare",
    notifications: "Benachrichtigungen",
    new: "Neu",
    contacted: "Kontaktiert",
    qualified: "Qualifiziert",
    placed: "Vermittelt",
    total: "Gesamt",
    name: "Name",
    phone: "Telefon",
    country: "Land",
    experience: "Erfahrung",
    job_title: "Position",
    language_level: "Sprachniveau",
    status: "Status",
    tags: "Tags",
    notes: "Notizen",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Erstellen",
    add_candidate: "Kandidat hinzufügen",
    add_post: "Neuer Post",
    add_template: "Neue Vorlage",
    add_form: "Neues Formular",
    title: "Titel",
    content: "Inhalt",
    platforms: "Plattformen",
    groups: "Gruppen",
    schedule: "Planen",
    scheduled_at: "Geplant für",
    bulk_post: "Massen-Post",
    generate: "Generieren",
    generation_type: "Generierungstyp",
    job_ad: "Stellenanzeige",
    tiktok_script: "TikTok-Skript",
    facebook_post: "Facebook-Post",
    copy: "Kopieren",
    copied: "Kopiert!",
    hashtags: "Hashtags",
    details: "Details",
    trigger_keyword: "Auslöser-Stichwort",
    message: "Nachricht",
    whatsapp: "WhatsApp",
    messenger: "Messenger",
    form_title: "Formulartitel",
    form_description: "Beschreibung",
    fields: "Felder",
    add_field: "Feld hinzufügen",
    public_link: "Öffentlicher Link",
    submissions: "Bewerbungen",
    photo: "Foto",
    cv: "Lebenslauf",
    welcome_back: "Willkommen zurück",
    sign_in_subtitle: "Zugriff auf Ihren Agentur-Bereich.",
    create_account: "Konto erstellen",
    signup_subtitle: "Rekrutieren Sie schneller.",
    overview: "Übersicht",
    recent_candidates: "Neueste Kandidaten",
    recent_activity: "Neueste Aktivität",
    no_data: "Keine Daten",
    mark_all_read: "Alle als gelesen markieren",
    unread: "Ungelesen",
    all: "Alle",
    copy_link: "Link kopieren",
    view_submissions: "Bewerbungen ansehen",
    add: "Hinzufügen",
    required: "Erforderlich",
    field_label: "Bezeichnung",
    field_type: "Typ",
    options_csv: "Optionen (durch Komma getrennt)",
    apply_now: "Bewerben",
    submit: "Absenden",
    thanks_submission: "Danke! Ihre Bewerbung wurde gesendet.",
    hero_headline: "Automatisieren Sie Ihre Rekrutierung.",
    hero_sub: "Posten Sie auf Facebook, Instagram und TikTok. Erstellen Sie Anzeigen mit KI. Verwalten Sie Kandidaten in einer klaren Pipeline.",
    features: "Funktionen",
    pricing: "Preise",
    contact: "Kontakt",
    feature_1_title: "Social-Planer",
    feature_1_desc: "Veröffentlichen und planen Sie auf mehreren Plattformen und Gruppen mit einem Klick.",
    feature_2_title: "KI-Copywriter",
    feature_2_desc: "Erstellen Sie Stellenanzeigen, TikTok-Skripte und Facebook-Posts in Sekunden.",
    feature_3_title: "Kandidaten-CRM",
    feature_3_desc: "Visuelle Pipeline von Neu bis Vermittelt mit Notizen und Tags.",
    feature_4_title: "Formulare",
    feature_4_desc: "Erfassen Sie Foto, Lebenslauf und Sprachniveau auf einer öffentlichen Seite.",
    country_ph: "z.B. Ungarn",
    job_title_ph: "z.B. Schweißer",
    details_ph: "z.B. Vollzeit, 2500€/Monat, Unterkunft inklusive",
    select_language: "Sprache",
    drafts: "Entwürfe",
    scheduled: "Geplant",
    published: "Veröffentlicht",
    groups_csv: "Gruppen (durch Komma getrennt)",
    tags_csv: "Tags (durch Komma getrennt)",
    confirm_delete: "Löschen bestätigen?",
    back: "Zurück",
    settings: "Einstellungen",
    pipeline: "Pipeline",
    total_candidates: "Kandidaten gesamt",
    total_posts: "Posts gesamt",
    active_forms: "Aktive Formulare",
    go: "Los",
    billing: "Abrechnung",
    pricing_headline: "Einfache Preise. Keine Überraschungen.",
    pricing_sub: "Testen Sie RecruitFlow AI {days} Tage kostenlos. Keine Kreditkarte nötig.",
    start_trial: "{days} Tage kostenlos testen",
    no_card_trial: "Keine Kreditkarte für den Test erforderlich.",
    month: "Mo.",
    popular: "Beliebt",
    current: "Aktuell",
    current_plan: "Aktueller Plan",
    subscribe: "Abonnieren",
    start_after_trial: "Jetzt aktivieren",
    trial: "Test",
    active: "Aktiv",
    days_left: "Tage übrig",
    renewed_until: "Verlängert bis",
    trial_ends: "Testzeitraum endet",
    verifying_payment: "Zahlung wird geprüft…",
    please_wait: "Bitte warten.",
    payment_success: "Zahlung erfolgreich!",
    plan_activated: "Plan aktiviert",
    billing_note: "Sichere monatliche Zahlung über Stripe. Jederzeit kündbar.",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rf_lang") || "fr");
  useEffect(() => { localStorage.setItem("rf_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
